<section
  floAnalytics
  tagName="Stream Tile"
  events="click"
  [analyticsProperties]="view.analyticProps"
  class="cursor-pointer"
>
  <ng-container *ngIf="eventHasSportData; else noSportData">
    <flo-stream-tile-sport-data
      data-test="stream-tile-with-sport-data"
      [view]="view"
      [sportData]="sportData"
    >
    </flo-stream-tile-sport-data>
  </ng-container>
  <ng-template #noSportData>
    <flo-stream-tile-no-sport-data
      data-test="stream-tile-without-sport-data"
      [view]="view"
    ></flo-stream-tile-no-sport-data>
  </ng-template>
</section>
